import { BrandConfig } from '../types';

export const jogoglobalAdminConfig: BrandConfig = {
  id: 'jogoglobal-admin',
  name: 'Jogo Global',
  displayName: 'Jogo Global',
  logo: 'JG-logo.png',
  primaryColor: '#4aa4fc',
  categories: [
    {
      name: 'BeeBet',
      banner: 'banners/banner_beebet.png',
      gamesPath: 'brands/beeBet.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'BetMGM',
      banner: 'banners/banner_everi-betmgm.jpg',
      gamesPath: 'brands/betmgm.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Betfred',
      banner: 'banners/banner_betfred.png',
      gamesPath: 'brands/betfred.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Entain',
      banner: 'banners/banner_Entain.jpg',
      gamesPath: 'brands/entain.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Esportes Da Sorte',
      banner: 'banners/banner_esportesdasorte.png',
      gamesPath: 'brands/esportesDaSorte.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Estrela Bet',
      banner: 'banners/banner_estrelabet.png',
      gamesPath: 'brands/estrelaBet.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Everi',
      banner: 'banners/banner_Everi.jpg',
      gamesPath: 'brands/everi.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'FanDuel',
      banner: 'banners/banner_Fanduel.jpg',
      gamesPath: 'brands/fanduel.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Jogo Games',
      banner: 'banners/banner_JG.png',
      gamesPath: 'brands/jogoGames.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Novibet',
      banner: 'banners/banner_novibet.png',
      gamesPath: 'brands/novibet.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    },
    {
      name: 'Others',
      banner: 'banners/banner_outros.png',
      gamesPath: 'brands/others.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    }
  ],
  defaultBanners: []
};
